<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="visible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="form.others" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="产品名称">
            <a-input v-model="form.others.name" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="批号">
            <a-input v-model="form.others.number" />
          </a-form-model-item>
          <a-form-model-item prop="output" label="生产量">
            <a-input v-model="form.others.output" />
          </a-form-model-item>
          <a-form-model-item prop="additive_name" label="添加剂名称">
            <a-input v-model="form.others.additive_name" />
          </a-form-model-item>
          <a-form-model-item prop="used" label="使用量">
            <a-input v-model="form.others.used" />
          </a-form-model-item>
          <a-form-model-item prop="handle_time" label="使用时间">
            <a-date-picker v-model="form.others.handle_time" valueFormat="YYYY-MM-DD" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item prop="user" label="使用人">
            <a-input v-model="form.others.user" />
          </a-form-model-item>
          <a-form-model-item prop="head" label="负责人">
            <a-input v-model="form.others.head" />
          </a-form-model-item>
          <a-form-model-item prop="contact" label="联系人">
            <a-input v-model="form.others.contact" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="form.others.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="form.others.email" />
          </a-form-model-item>
          <a-form-model-item prop="address" label="地址">
            <a-input v-model="form.others.address" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="form.others.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { additivesAdd, additivesEdit } from "@/api/produce";

export default {
  name: "FormModal",
  props: ["visible", "form", "clientsClassificationOptions"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
          { max: 64, message: "超出最大长度 (64)", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入批号", trigger: "blur" },
          { max: 32, message: "超出最大长度 (32)", trigger: "blur" },
        ]
      },
      loading: false,
    };
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? additivesEdit : additivesAdd;
          func(this.form)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "新增成功");
              this.$emit(this.form.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if(!this.form.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style scoped></style>
